/* eslint-disable no-console */
import { Injectable } from '@angular/core';
import { ErrorCodes } from '@shared';
import { LoggingService } from '@shared/logging';
import jwt_decode from 'jwt-decode';
import { DecodeJWTResultModel } from '../models/decode-jwt-result.model';

@Injectable()
export class DecodeJWTService {
	public constructor(private loggingService: LoggingService) {}

	public parseJwt(token: string): DecodeJWTResultModel {
		try {
			return jwt_decode(token);
		} catch (error) {
			this.loggingService.error(ErrorCodes.RegistrationDecodeJWTTokenError, error);
			throw new Error('Decoding registration token failed');
		}
	}

	public getDeviceIds(token: string): string[] {
		return this.parseJwt(token).dev;
	}
}
